import { render, staticRenderFns } from "./VideoElementPublish.vue?vue&type=template&id=3931fc15&"
import script from "./VideoElementPublish.vue?vue&type=script&lang=ts&"
export * from "./VideoElementPublish.vue?vue&type=script&lang=ts&"
import style0 from "./VideoElementPublish.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports